import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IAdController} from "views/components/ad/ad.controller";
import styled from "@emotion/styled";
import {useSearchParams} from "react-router-dom";

const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 32px auto;

	&.fantasy-midcontent {
		min-height: 300px;
	}

	&.fantasy-ticker {
		min-height: 36px;
	}

	${({theme}) => theme.breakpoints.down("md")} {
		&.fantasy-midcontent {
			margin: 16px auto;
		}

		&.fantasy-ticker {
			display: none;
		}
	}
`;

interface IProps {
	divId: string;
	baseDivId: string;
	pos: string;
}

export const Ad: React.FC<IProps> = observer(({baseDivId, divId, pos}) => {
	const [searchParams] = useSearchParams();
	useViewController<IAdController>(Bindings.AdController, {
		divId,
		baseDivId,
		pos,
		ad_test: searchParams.get("ad_test"),
	});

	return <Wrapper className={divId} id={divId} />;
});
